module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg viewBox=\"0 0 31 60\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" >\n    <g id=\"Page-1\" stroke=\"none\" stroke-  fill-rule=\"evenodd\">\n        <g id=\"lightening\" fill-rule=\"nonzero\" >\n            <g id=\"Group\">\n                <g id=\"Shape\">\n                    <polyline points=\"24.766 10 30.766 0 15.428 0 4.252 19 10.382 19 2.382 35 8.59 35 0.003 59.536 25.031 27 19.661 27 28.661 10 24.766 10\"></polyline>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/lightening.svg
// module id = 2815
// module chunks = 0